import Vue from 'vue';
import Vuex from 'vuex';
import Storage from './localStorage'
import MobileLogin from '../views/login/mobileLogin.vue';

Vue.use(Vuex);

const state = {
	username: "",
	password: "",
	globalSessionid: Storage.getItem("globalSessionid") || {}, //称重 登陆时，获取全局参数
	companyName: Storage.getItem("companyName") || '', //称重 登陆时，获取全局公司名称
	sidebar: {                                            //左侧菜单
		opened: Storage.getItem('sidebarStatus') ? !!+Storage.getItem('sidebarStatus') : false,
		withoutAnimation: false,
		list: []
	},
	loginName: Storage.getItem("loginName") || '',//登陆账号
	loginData: Storage.getItem("loginData") || '',//登陆后获取数据

	adminLoginName: Storage.getItem("adminLoginName") || '',//登陆账号 admin

	adminLoginName69: Storage.getItem("adminLoginName69") || '',//登陆账号 admin
	field: Storage.getItem("field") || {},//显示字段
	fieldList: Storage.getItem("fieldList") || {},//显示字段


	cloudfield: Storage.getItem("cloudfield") || {},//云称重显示字段
	cloudFieldList: Storage.getItem("cloudFieldList") || {},//云称重显示字段


	session: Storage.getItem("session") || {},
	globalVar: Storage.getItem("globalVar") || {}, //全局变量数组
	globalRoute: Storage.getItem("globalRoute") || '', //全局路径
	arid: Storage.getItem("arid") || '', //全局资产负债表id
	globalButton: Storage.getItem("globalButton") || '', //全局按钮

	weightType: Storage.getItem("weightType") || '', //过磅类型
	// 同业业务
	indexNum: "",
	// 排序 名称
	prop: Storage.getItem("prop") || '',
	// 升降序
	order: Storage.getItem("order") || '',
	// 菜单id
	menuId: Storage.getItem("menuId") || '',


	companyID: Storage.getItem("companyID") || '',
	carNo: Storage.getItem("carNo") || '',

	companyUser: Storage.getItem("companyUser") || '',
	companyPassword: Storage.getItem("companyPassword") || '',
	rank: Storage.getItem("rank") || {},

	nowCompanyName: Storage.getItem("nowCompanyName") || '',
	nowCompanyID: Storage.getItem("nowCompanyID") || '',
	goodsUserName: Storage.getItem("goodsUserName") || '',
	goodsPwd: Storage.getItem("goodsPwd") || '',

	// 全局称重操作的form
	weightFrom: Storage.getItem("weightFrom") || {},

	// 全局变量存储登录不同的系统
	loginType: Storage.getItem("loginType") || '',

	// 移动端预约记录车号  mobileCarNo
	mobileCarNo: Storage.getItem("mobileCarNo") || '',

	// 移动端登录的时候获取使用习惯 新版或者旧版界面
	mobileLoginNewOrOld: Storage.getItem("mobileLoginNewOrOld") || 'new',

	// 移动端定制10948 记录车号和3个备用信息
	mobileCustomization10948: Storage.getItem("mobileCustomization10948") || {},

	// 移动端定制10948 记录车号和3个备用信息
	mobileCustomization10948_2: Storage.getItem("mobileCustomization10948_2") || {},

}

const mutations = {
	// 存储用户名
	username(state, user) {
		state.username = user;
		Storage.setItem(`username`, user)
	},
	// 存储密码
	password(state, user) {
		state.password = user;
		Storage.setItem(`password`, user)
	},

	// 全局变量存储登录不同的系统
	getLoginType(state, index) {
		state.loginType = index
		Storage.setItem(`loginType`, index)
	},


	// 称重 登陆时，获取全局参数
	login(state, user) {
		state.globalSessionid = user;
		Storage.setItem(`globalSessionid`, user)
	},
	getLoginData(state, user) {
		state.loginData = user;
		Storage.setItem(`loginData`, user)
	},
	//获取公司名字
	companyst(state, user) {
		state.companyName = user;
		Storage.setItem(`companyName`, user)
	},
	//获取登陆账号
	getLoginName(state, user) {
		state.loginName = user;
		Storage.setItem(`loginName`, user)
	},


	//获取登陆账号  adminLogin
	getAdminLoginName(state, user) {
		state.adminLoginName = user;
		Storage.setItem(`adminLoginName`, user)
	},

	getAdminLogin69(state, user) {
		state.adminLoginName69 = user;
		Storage.setItem(`adminLoginName69`, user)
	},


	//获取字段显示
	getField(state, user) {
		state.field = user;
		Storage.setItem(`field`, user)
	},

	//云称重获取字段显示
	getCloudField(state, user) {
		state.cloudfield = user;
		Storage.setItem(`cloudfield`, user)
	},

	fieldList(state, user) {
		state.fieldList = user;
		Storage.setItem(`fieldList`, user)
	},

	// 云称重字段列表
	getCloudFieldList(state, user) {
		state.cloudFieldList = user;
		Storage.setItem(`cloudFieldList`, user)
	},

	// 获取全局对象
	getGlobal(state, user) {
		state.globalVar = user;
		Storage.setItem(`globalVar`, user)
	},

	getSession(state, user) {
		state.session = user;
		Storage.setItem(`session`, user)
	},

	//全局按钮
	getButton(state, user) {
		state.globalButton = user;
		Storage.setItem(`globalButton`, user)
	},

	//全局路径
	getGlobalRoute(state, user) {
		state.globalRoute = user;
		Storage.setItem(`globalRoute`, user)
	},
	//全局的userid
	getArid(state, user) {
		state.arid = user;
		Storage.setItem(`arid`, user)
	},

	getProp(state, user) {
		state.prop = user;
		Storage.setItem(`prop`, user)
	},


	getCompanyID(state, user) {
		state.companyID = user;
		Storage.setItem(`companyID`, user)
	},

	getCarNo(state, user) {
		state.carNo = user;
		Storage.setItem(`carNo`, user)
	},

	getCompanyUser(state, user) {
		state.companyUser = user;
		Storage.setItem(`companyUser`, user)
	},

	getPassword(state, user) {
		state.companyPassword = user;
		Storage.setItem(`companyPassword`, user)
	},


	getRank(state, user) {
		state.rank = user;
		Storage.setItem(`rank`, user)
	},


	getNowCompanyName(state, user) {
		state.nowCompanyName = user;
		Storage.setItem(`nowCompanyName`, user)
	},

	getNowCompanyID(state, user) {
		state.nowCompanyID = user;
		Storage.setItem(`nowCompanyID`, user)
	},


	getGoodsUserName(state, user) {
		state.goodsUserName = user;
		Storage.setItem(`goodsUserName`, user)
	},

	getGoodsPwd(state, user) {
		state.goodsPwd = user;
		Storage.setItem(`goodsPwd`, user)
	},


	// 获取过磅类型
	getWeightType(state, index) {
		state.weightType = index
		Storage.setItem(`weightType`, index)
	},


	// 获取称重操作的form
	getWeightForm(state, index) {
		state.weightFrom = index
		Storage.setItem(`weightFrom`, index)
	},


	// 移动端登录的时候获取使用习惯 新版或者旧版界面
	getMobileLoginNewOrOld(state, index) {
		state.mobileLoginNewOrOld = index
		Storage.setItem(`mobileLoginNewOrOld`, index)
	},

	// 移动端定制10948
	getMobileCarNo(state, index) {
		state.mobileCarNo = index;
		Storage.setItem(`mobileCarNo`, index);
	},



	// 移动端定制10948
	getMobileCustomization10948(state, index) {
		state.mobileCustomization10948 = index;
		Storage.setItem(`mobileCustomization10948`, index);
	},
	getMobileCustomization10948_2(state, index) {
		state.mobileCustomization10948_2 = index;
		Storage.setItem(`mobileCustomization10948_2`, index);
	},




	// 退出
	logout(state, user) {
		state.globalSessionid = "";
		state.globalVar = "";
		state.adminLoginName69 = "";
		state.adminLoginName = "";
		state.loginData = "";
		state.loginType = "";




		Storage.clear(`globalSessionid`, "");
		Storage.clear(`globalVar`, "");
		Storage.clear(`adminLoginName`, "");
		Storage.clear(`adminLoginName69`, "");
		Storage.clear(`loginData`, "");
		Storage.clear(`loginType`, "");



		// state.companyUser = "";
		// state.companyPassword = "";
		// state.rank = "";
		// Storage.clear(`companyUser`, "");
		// Storage.clear(`companyPassword`, "");
		// Storage.clear(`rank`, "");
	},

	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened
		state.sidebar.withoutAnimation = false
		if (state.sidebar.opened) {
			Storage.setItem('sidebarStatus', 1)
		} else {
			Storage.setItem('sidebarStatus', 0)
		}
	},

	// 同业业务获取年限
	getIndexNum(state, user) {
		state.indexNum = user;
	},

	// 获取菜单id
	getMenuId(state, user) {
		state.menuId = user;
		Storage.setItem(`menuId`, user)
	}
}
// 更改数据
const actions = {
	getGlobal(context, payload) {
		context.commit('globalVar', payload)
	},

	toggleSideBar({
		commit
	}) {
		commit('TOGGLE_SIDEBAR')
	},
}

const getters = {
	sidebar: state => state.sidebar,
}
const store = new Vuex.Store({
	state,
	mutations,
	actions,
	getters
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js